// 单位转换显示：将数值转为模糊的kk展示，例如1999 = 1k
export function unitConversion(num) {
  if (num != 0 && !num) {
    console.error(`错误的数值${num}`);
    return 0;
  }
  // 小于10000直接返回
  if (num < 10000) {
    return num;
  }
  return unitConversionRecursion(num);
}
// 递归计算：等于10000=10k 大于10000 = 10k+ 1,999,999 = 1kk+  1,000,000,000 = 1kkk  9,999,999 = 9kk+
// 能整除1000的不带+号，不能的则带+号
function unitConversionRecursion(num) {
  const val = Number(num.toString().split('K')[0]);
  const unit = num.toString().split(val)[1];
  if (val / 1000 >= 1000) {
    // 除1000还大于1000继续递归
    return unitConversionRecursion(`${Math.floor(val / 1000)}${unit ? 'K' + unit : val % 1000 === 0 ? 'K' : 'K+'}`);
  } else if (val % 1000 === 0) {
    return `${Math.floor(val / 1000)}${unit ? 'K' + unit : 'K'}`;
  }
  return `${Math.floor(val / 1000)}${unit ? 'K' + unit : 'K+'}`;
}
